
import qs from 'qs'
import router from './../../router'

const state = {
    reportSKProcessing: false,
    reportAreaProcessing: false,
    reportOrderProcessing: false,
    callingListProcessing: false,
    nextVictim: null,
    callingList: [],
    pollsApproved: [],
    answerTypes: [],
    historyList: [],
    phones: [],
    reportSK: [],
    reportArea: [],
    reportOrder: [],
    vaccinCovidBranches: [],
    selectedPatient: null,
    docTypes: [],
    doc_type: null,
    perPage: 200,
    currentPage: 1,
    selectedBranch: null,
    currentCall: null,
    faq: '',
    interviewLink: '',
    interviewLinkForeign: '',
    commentText: '',
    victimOptions: {
        id_call: null
    },
    covidOptions: {
        med: 0,
        orz: 0,
        soc: 0,
        socContract: 0,
        psych: 0,
        lec: 0,
        answer: 0
    },
    resError: null,
    errorText: null,
    qr_tk: null,
    id_patient: null,
    id_doc: null,
    documentPath: null,
    searchByAllBranches: '',
    sortOption: {
        text: 'По №. Послед.', value: -1
    }
}

const getters = {
    nextTelParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'Get_new_call'
        }))
    },
    callingListParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'Get_calling_list',
            id_branch: state.selectedBranch.id,
            sort_type: state.sortOption.value,
            str_param: '',
            n_page: state.currentPage,
            page_size: state.perPage
        }))
    },
    globalSearchParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'Get_calling_list',
            id_branch: state.selectedBranch.id,
            sort_type: state.sortOption.value,
            str_param: state.searchByAllBranches.trim(),
            n_page: 1,
            page_size: state.perPage
        }))
    },
    faqParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'faq'
        }))
    },
    currentCallParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'get_current_call'
        }))
    },
    recallParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'Get_re_call',
            id_call: state.victimOptions.id_call
        }))
    },
    saveCallParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'finish_call',
            soc: state.covidOptions.soc,
            soc_contract: state.covidOptions.socContract,
            med: state.covidOptions.med, 
            lec: state.covidOptions.lec,
            psych: state.covidOptions.psych, 
            comment: state.commentText,
            id_call: state.nextVictim.id_call,
            orz: state.covidOptions.orz,
            id_answer_type: state.covidOptions.answer
        }))
    },
    finishCallParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'finish_call',
            id_call: state.nextVictim.id_call,
            id_answer_type: state.covidOptions.answer
        }))
    },
    answerTypesParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'get_answer_types',
        }))
    },
    historyListParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'history_list',
            id_call: state.nextVictim.id_call
        }))
    },
    reportSKParams: (state, getters, rootState) => {
        return JSON.stringify({
            Name_app: 'Covid',
            Name_module: 'Covid',
            Name_event: 'report_sk',
            id_action: 1
        })
    },
    reportAreaParams: (state, getters, rootState) => {
        return JSON.stringify({
            Name_app: 'Covid',
            Name_module: 'Covid',
            Name_event: 'report_area',
            id_action: 2
        })
    },
    reportOrderParams: (state, getters, rootState) => {
        return JSON.stringify({
            Name_app: 'Covid',
            Name_module: 'Covid',
            Name_event: 'report_order',
            id_action: 3
        })
    },
    vaccinCovidBranchesParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'vaccin_covid_branches'
        }))
    },
    interviewLinkParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'interview_link',
            id_branch: state.selectedBranch.id,
            link_type: state.selectedBranch.link_type
        }))
    },
    interviewLinkForeignParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'interview_link_foreign',
            id_branch: state.selectedBranch.id,
            link_type: state.selectedBranch.link_type
        }))
    },

    crPatFromPollparams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'POST:cr_pat_from_poll',
            qr_tk: state.qr_tk,
            id_branch: state.selectedBranch.id
        }))
    },
    documentsParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'WEB_division',
            Name_event: 'get_docs',
            id_patient: state.id_patient
        }))
    }, 
    documentPathParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'WEB_division',
            Name_event: 'get_pic_path',
            id_doc: state.id_doc
        }))
    }, 

    secondWaveParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'POST:vacc_second_wave',
            qr_tk: state.qr_tk,
            id_branch: state.selectedBranch.id
        }))
    },
    pollsApprovedParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'GET:polls_approved',
            id_branch: state.selectedBranch.id
        }))
    },
    docTypesParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'GET:vac_doc_list',
            qr_tk: state.selectedPatient.tk12121212,
        }))
    },

    approveThePollParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'POST:aprrove_the_poll',
            qr_tk: state.qr_tk,
            str_param: '1'
        }))
    },
    disapproveThePollParams: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
            Name_module: 'Covid',
            Name_event: 'POST:aprrove_the_poll',
            qr_tk: state.qr_tk,
            str_param: '0'
        }))
    },
}


const mutations = {
    NEW_TEL(state, payload) {
        state.phones = [];
        state.nextVictim = payload.body[0];
        state.phones = state.nextVictim.tel.split(',');
    },
    CALLING_LIST(state, payload) {
        state.callingList = payload.body;
        state.callingList.forEach(i => {
            if (i.email_errors === 1) {
                i._rowVariant = 'danger';
                i.email = `ОШИБКА: ${i.email}`
            } else if (!i.polis || !i.snils || !i.enfluence_org) {
                i._rowVariant = 'danger';
            }
        })
    },
    CALLING_LIST_PROCESSING(state, payload) {
        state.callingListProcessing = payload;
    },
    CURRENT_CALL(state, payload) {
        state.currentCall = payload.body[0];
    },
    CHECK_FINISH_CALL(state, payload) {
        console.log(payload.errorText)
    },
    ANSWER_TYPES(state, payload) {
        state.answerTypes = payload.body;
    },
    CLEAR_VICTIM(state, payload) {
        state.nextVictim = null;
    },
    SELECT_MED(state, payload) {
        state.covidOptions.med = payload;
    },
    SELECT_ORZ(state, payload) {
        state.covidOptions.orz = payload;
    },
    SELECT_SOC(state, payload) {
        state.covidOptions.soc = payload;
    },
    SELECT_SOC_CONTRACT(state, payload) {
        state.covidOptions.socContract = payload;
    },
    SELECT_ANSWER(state, payload) {
        state.covidOptions.answer = payload;
    },
    UPDATE_COMMENT(state, payload) {
        state.commentText = payload;
    },
    HISTORY_LIST(state, payload) {
        state.historyList = payload.body;
    },
    SELECT_LEC(state, payload) {
        state.covidOptions.lec = payload;
    },
    SELECT_PSYCH(state, payload) {
        state.covidOptions.psych = payload;
    },
    SET_ID_CALL(state, payload) {
        state.victimOptions.id_call = payload;
    },
    FAQ(state, payload) {
        state.faq = payload.body[0].faq;
    },
    REPORT_SK(state, payload) {
        state.reportSK = payload.body;
    },
    REPORT_AREA(state, payload) {
        state.reportArea = payload.body;
    },
    REPORT_ORDER(state, payload) {
        state.reportOrder = payload.body;
    },
    REPORT_SK_PROCESSING(state, payload) {
        state.reportSKProcessing = payload;
    },
    REPORT_AREA_PROCESSING(state, payload) {
        state.reportAreaProcessing = payload;
    },
    REPORT_ORDER_PROCESSING(state, payload) {
        state.reportOrderProcessing = payload;
    },
    VACCIN_COVID_BRANCHES(state, payload) {
        state.vaccinCovidBranches = payload.body;

        let flag = state.vaccinCovidBranches[0].id ;
        let unique = [state.vaccinCovidBranches[0]];
        state.vaccinCovidBranches.forEach((i, index) => {
            if (index > 0) {
                if (i.id !== flag) { 
                    unique = [...unique, i];
                    flag = i.id;
                }
            }
        })


        if (state.selectedBranch) {
            let matchIndex;
            let match = state.vaccinCovidBranches.filter((i, index) => {
                if (i.id === state.selectedBranch.id) {
                    matchIndex = index;
                    return;
                }
            })
            state.selectedBranch.pat_cnt = state.vaccinCovidBranches[matchIndex].pat_cnt;
        }
    },
    CLEAR_CALLING_LIST(state, payload) {
        state.callingList = [];
    },
    INTERVIEW_LINK(state, payload) {
        state.interviewLink = payload.body[0].link;
    },
    SET_BRANCH(state, payload) {
        state.selectedBranch = payload;
    },
    CLEAR_BRANCH(state) {
        state.selectedBranch = null
    },
    RESET_ERROR(state) {
        state.resError = null;
        state.errorText = null;
    },
    SET_QR_TK(state, payload) {
        state.qr_tk = payload;
    },
    RES_ERROR(state, payload) {
        let res = payload.body[0]
        state.resError = res.err;
        if (state.resError > 0) {
            state.errorText = res.err_txt;
        }
    },
    SET_ID_PATIENT(state, payload) {
        state.id_patient = payload;
    },
    DOCUMENTS(state, payload) {
        state.documents = payload.body
        state.documents.forEach(i => {
            if (i.doc_name.includes('Анкета')) {
                state.id_doc = i.id_doc;
                return;
            }
        })
    },
    SET_ID_DOC(state, payload) {
        state.id_doc = payload;
    },
    DOCUMENT_PATH(state, payload) {
        state.documentPath = payload.body[0];
    },
    SEARCH_BY_ALL_BRANCHES(state, payload) {
        state.searchByAllBranches = payload;
    },
    UPDATE_CURRENT_PAGE(state, payload) {
        state.currentPage = payload;
    },
    UPDATE_PER_PAGE_VALUE(state, payload) {
        state.perPage = payload;
    }, 
    POLLS_APPROVED(state, payload) {
        state.pollsApproved = payload.body;
    },
    DOC_TYPES(state, payload) {
        state.docTypes = payload.body;
    },
    SET_DOC_TYPE(state, payload) {
        state.doc_type = payload;
    },
    SELECT_PATIENT(state, payload) {
        state.selectedPatient = payload;
    },
    SET_SORT_OPTION(state, payload) {
        state.sortOption = payload;
    },
    INTERVIEW_LINK_FOREIGN(state, payload) {
        state.interviewLinkForeign = payload.body[0].link;
    }
}

const actions = {
    selectMed({ commit }, context) {
        commit('SELECT_MED', context)
    },
    selectORZ({ commit }, context) {
        commit('SELECT_ORZ', context)
    },
    selectSoc({ commit }, context) {
        commit('SELECT_SOC', context)
    },
    selectSocContract({ commit }, context) {
        commit('SELECT_SOC_CONTRACT', context)
    },
    selectLec({ commit }, context) {
        commit('SELECT_LEC', context)
    },
    selectPsych({ commit }, context) {
        commit('SELECT_PSYCH', context)
    },
    selectAnswer({ commit }, context) {
        commit('SELECT_ANSWER', context)
    },
    updateComment({ commit }, context) {
        commit('UPDATE_COMMENT', context)
    },
    clearBranch({commit}) {
        commit('CLEAR_BRANCH')
    },
    clearCallingList({commit}) {
        commit('CLEAR_CALLING_LIST');
    },
    setDocType({ commit }, payload) {
        commit('SET_DOC_TYPE', payload)
    },
    updatePerPageValue({commit, dispatch}, context) {
        commit('UPDATE_PER_PAGE_VALUE', context);
        dispatch('getCallingList')
    },
    updateCurrentpage({commit, dispatch}, context) {
        commit('UPDATE_CURRENT_PAGE', context);
        dispatch('getCallingList');
    },
    updateSearchByAllBranches({commit, dispatch}, context) {
        commit('SEARCH_BY_ALL_BRANCHES', context);
        if (context.length === 0) dispatch('getCallingList');
    },
    selectPatient({ commit }, payload) {
        commit('SELECT_PATIENT', payload);
    },
    setSortOption({ commit, dispatch }, context) {
        commit('SET_SORT_OPTION', context);
        dispatch('getCallingList');
    },

    globalSearch: async({commit, state, getters}) => {
        commit('CALLING_LIST_PROCESSING', true);
        try {
            let callingListResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.globalSearchParams}`);
            if (callingListResponse.status >= 200 && callingListResponse.status < 300) {
                let res = await callingListResponse.json();
                if (res.errorText === "Incorrect token") {
                    commit('UPDATE_CHECK', false, { root: true });
                    commit('END_SESSION', 0, { root: true });
                    router.push({ name: 'stop-covid' });
                } else {
                    commit('CALLING_LIST', res);
                    commit('CALLING_LIST_PROCESSING', false);
                }
            }
        } catch(err) { err => console.error(err) }
    },

    getNewTel: async({commit, state, getters}) => {
        try {
            let nextTelParams = getters.nextTelParams;
            let nextTelResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${nextTelParams}`);
            if (nextTelResponse.status >= 200 && nextTelResponse.status < 300) {
                let res = await nextTelResponse.json()
                if (res.body.length === 0) {
                    commit('FIRST_VICTIM_CHECK', true, { root: true })
                } else commit('NEW_TEL', res);
            }
            let historyListParams = getters.historyListParams;
            let historyResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${historyListParams}`);
            if (historyResponse.status >= 200 && historyResponse.status < 300) {
                commit('HISTORY_LIST', await historyResponse.json());
            }
        } catch(err) { err => console.error(err) }
    },

    getFaq: async({commit, state, getters}) => {
        try {
            let faqParams = getters.faqParams;
            let faqResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${faqParams}`);
            if (faqResponse.status >= 200 && faqResponse.status < 300) {
                commit('FAQ', await faqResponse.json());
            }
        } catch(err) { err => console.error(err) }
    },


    getRecall: async({commit, state, getters}, context) => {
        commit('SET_ID_CALL', context)
        try {
            let recallParams = getters.recallParams;
            let recallResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${recallParams}`);
            if (recallResponse.status >= 200 && recallResponse.status < 300) {
                commit('NEW_TEL', await recallResponse.json());
                commit('SELECT_MED', 0);
                commit('SELECT_ORZ', 0);
                commit('SELECT_SOC_CONTRACT', 0);
                commit('SELECT_SOC', 0);
                commit('SELECT_LEC', 0);
                commit('SELECT_PSYCH', 0);
                commit('SELECT_ANSWER', 0);
                commit('UPDATE_COMMENT', '');
            }
            let historyListParams = getters.historyListParams;
            let historyResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${historyListParams}`);
            if (historyResponse.status >= 200 && historyResponse.status < 300) {
                commit('HISTORY_LIST', await historyResponse.json());
            }
        } catch(err) { err => console.error(err) }
    },

    getCallingList: async({commit, state, dispatch, getters}) => {
        await dispatch('updateVaccinCovidBranches');
        commit('CALLING_LIST_PROCESSING', true);
        try {
            let callingListParams = getters.callingListParams;
            let callingListResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${callingListParams}`);
            if (callingListResponse.status >= 200 && callingListResponse.status < 300) {
                let res = await callingListResponse.json();
                if (res.errorText === "Incorrect token") {
                    commit('UPDATE_CHECK', false, { root: true });
                    commit('END_SESSION', 0, { root: true });
                    router.push({ name: 'stop-covid' });
                } else {
                    commit('CALLING_LIST', res);
                    commit('CALLING_LIST_PROCESSING', false);
                }
            }
            
        } catch(err) { err => console.error(err) }
    },

    getAnswerTypes: async({commit, state, getters}) => {
        try {
            let answerTypesParams = getters.answerTypesParams;
            let answerTypesResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${answerTypesParams}`);
            if (answerTypesResponse.status >= 200 && answerTypesResponse.status < 300) {
                commit('ANSWER_TYPES', await answerTypesResponse.json());
            }
        } catch(err) { err => console.error(err) }
    },

    getReportSK: async({commit, state, getters}) => {
        commit('REPORT_SK_PROCESSING', true)
        try {
            let reportSKResponse = await fetch(`https://host2.medsafe.tech/api/report`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.reportSKParams
                })
            });
            if (reportSKResponse.status >= 200 && reportSKResponse.status < 300) {
                commit('REPORT_SK', await reportSKResponse.json());
                commit('REPORT_SK_PROCESSING', false)
            }
        } catch(err) { err => console.error(err) }
    },

    getReportArea: async({commit, state, getters}) => {
        commit('REPORT_AREA_PROCESSING', true)
        try {
            let reportSKResponse = await fetch(`https://host2.medsafe.tech/api/report`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.reportAreaParams
                })
            });
            if (reportSKResponse.status >= 200 && reportSKResponse.status < 300) {
                commit('REPORT_AREA', await reportSKResponse.json());
                commit('REPORT_AREA_PROCESSING', false)
            }
        } catch(err) { err => console.error(err) }
    },

    getReportOrder: async({commit, state, getters}) => {
        commit('REPORT_ORDER_PROCESSING', true)
        try {
            let reportSKResponse = await fetch(`https://host2.medsafe.tech/api/report`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.reportOrderParams
                })
            });
            if (reportSKResponse.status >= 200 && reportSKResponse.status < 300) {
                commit('REPORT_ORDER', await reportSKResponse.json());
                commit('REPORT_ORDER_PROCESSING', false)
            }
        } catch(err) { err => console.error(err) }
    },

    saveCall: async({commit, state, getters, dispatch}) => {
        try {
            let saveCallResponse = await fetch(`https://host2.medsafe.tech/api/covid`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.saveCallParams
                })
            });
            if (saveCallResponse.status >= 200 && saveCallResponse.status < 300) {
                commit('CHECK_FINISH_CALL', await saveCallResponse.json());
                commit('CLEAR_VICTIM');
                commit('SELECT_MED', 0);
                commit('SELECT_SOC_CONTRACT', 0);
                commit('SELECT_ORZ', 0);
                commit('SELECT_SOC', 0);
                commit('SELECT_LEC', 0);
                commit('SELECT_PSYCH', 0);
                commit('SELECT_ANSWER', 0);
                commit('UPDATE_COMMENT', '');
                dispatch('getCallingList');
            }
        } catch(err) { err => console.error(err) }
    },
    getVaccinCovidBranches: async({commit, state, getters, dispatch}) => {
        await dispatch('clearBranch');
        await dispatch('clearCallingList');
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.vaccinCovidBranchesParams}`);
            if (res.status >= 200 && res.status < 300) {
                commit('VACCIN_COVID_BRANCHES', await res.json());
            }
        } catch(err) { err => console.error(err) }
    },
    updateVaccinCovidBranches: async({commit, state, getters, dispatch}) => {
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.vaccinCovidBranchesParams}`);
            if (res.status >= 200 && res.status < 300) {
                commit('VACCIN_COVID_BRANCHES', await res.json());
            }
        } catch(err) { err => console.error(err) }
    },
    getInterviewLink: async({commit, state, getters, dispatch}, branch) => {
        commit('SET_BRANCH', branch);
        try {
            let res1 = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.interviewLinkParams}`);
            if (res1.status >= 200 && res1.status < 300) {
                commit('INTERVIEW_LINK', await res1.json());
            }
            let res2 = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.interviewLinkForeignParams}`);
            if (res2.status >= 200 && res2.status < 300) {
                commit('INTERVIEW_LINK_FOREIGN', await res2.json());
            }
            dispatch('getCallingList');
        } catch(err) { err => console.error(err) }
    },
    

    crPatFromPoll: async({ commit, getters, dispatch, rootState }, qr_tk) => {
        commit('SET_QR_TK', qr_tk);
        commit('RESET_ERROR');
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.crPatFromPollparams}`, {
                method: 'POST'
            });
            if (res.status >= 200 && res.status < 300) {
                let resData = await res.json();
                if (resData.body[0].err === 0) {
                    commit('RES_ERROR', resData);
                } else {
                    commit('RES_ERROR', resData);
                }
            }
            dispatch('getCallingList');
        } catch(err) { err => console.error(err) }
    },


    getDocuments: async({commit, state, getters, dispatch}, id_patient) => {
        commit('SET_ID_PATIENT', id_patient);
        try {
            let documentsResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.documentsParams}`);
            if (documentsResponse.status >= 200 && documentsResponse.status < 300) {
                await commit('DOCUMENTS', await documentsResponse.json())
                await dispatch('getDocumentPath');
            }   
        } catch(err) { err => console.error(`Ошибка исполнения getDocuments: ${err}`) }
    },

    getDocumentPath: async({commit, state, getters}, id_doc_poll) => {
        commit('SET_ID_DOC', id_doc_poll);
        try {
            let documentPathResponse = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.documentPathParams}`);
            if (documentPathResponse.status >= 200 && documentPathResponse.status < 300) {
                commit('DOCUMENT_PATH', await documentPathResponse.json())
            }   
            let document = `https://host2.medsafe.tech/${state.documentPath.hash}`
            window.open(document, '_blank')
        } catch(err) { err => console.error(`Ошибка исполнения getDocumentPath: ${err}`) }
    },
    
    secondWave: async({ commit, getters, dispatch, rootState }, qr_tk) => {
        commit('SET_QR_TK', qr_tk);
        commit('RESET_ERROR');
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.secondWaveParams}`, {
                method: 'POST'
            });
            if (res.status >= 200 && res.status < 300) {
                let resData = await res.json();
                if (resData.body[0].err === 0) {
                    commit('RES_ERROR', resData);
                } else {
                    commit('RES_ERROR', resData);
                }
            }
            dispatch('getCallingList');
        } catch(err) { err => console.error(err) }
    },

    getPollsApproved: async({commit, state, getters, dispatch}) => {
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.pollsApprovedParams}`);
            if (res.status >= 200 && res.status < 300) {
                commit('POLLS_APPROVED', await res.json());
            }   
        } catch(err) { err => console.error(`Ошибка исполнения getPollsApproved: ${err}`) }
    },

    getDocTypes: async({commit, state, getters, dispatch}) => {
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.docTypesParams}`);
            if (res.status >= 200 && res.status < 300) {
                commit('DOC_TYPES', await res.json());
            }   
        } catch(err) { err => console.error(`Ошибка исполнения: ${err}`) }
    },

    approveThePoll: async({ commit, getters, dispatch, rootState }, qr_tk) => {
        commit('SET_QR_TK', qr_tk);
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.approveThePollParams}`, {
                method: 'POST'
            });
            if (res.status >= 200 && res.status < 300) {
                dispatch('getCallingList');
            }
        } catch(err) { err => console.error(err) }
    },

    disapproveThePoll: async({ commit, getters, dispatch, rootState }, qr_tk) => {
        commit('SET_QR_TK', qr_tk);
        try {
            let res = await fetch(`https://host2.medsafe.tech/api/test?json=${getters.disapproveThePollParams}`, {
                method: 'POST'
            });
            if (res.status >= 200 && res.status < 300) {
                dispatch('getCallingList');
            }
        } catch(err) { err => console.error(err) }
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/covid.js